import moment from 'moment';

export const setRequestData = (partner, owner, userId, isCounterOffer) => ({
    sender: {
        uid: userId,
        product: owner.selectedCampaign.project_id,
        image: owner.selectedCampaign.thumbnails && owner.selectedCampaign.thumbnails.medium || owner.selectedCampaign.image,
        title: owner.selectedCampaign.title,
        spot_position: owner.selectedSpot.index,
        campaign: owner.selectedCampaign.id,
        update_date: moment.utc(owner.selectedSpot.date, 'DD/MM/YYYY').toDate(),
        update_date_id: owner.selectedSpot.id,
        project_url: owner.selectedCampaign.project_url,
        platform: owner.selectedCampaign.platform
    },
    receiver: {
        uid: partner.campaign.author_id,
        product: partner.campaign.project_id,
        image: partner.campaign.thumbnails && partner.campaign.thumbnails.medium || partner.campaign.image,
        title: partner.campaign.title,
        spot_position: partner.selectedSpot.index,
        campaign: partner.campaign.id,
        update_date: moment.utc(partner.selectedSpot.date, 'DD/MM/YYYY').toDate(),
        update_date_id: partner.selectedSpot.id,
        project_url: partner.campaign.project_url,
        platform: partner.campaign.platform
    },
    campaigns: [
        owner.selectedCampaign.id + '_' + partner.campaign.id,
        partner.campaign.id + '_' + owner.selectedCampaign.id,
        owner.selectedCampaign.id,
        partner.campaign.id
    ],
    products: [
        owner.selectedCampaign.project_id + '_' + partner.campaign.project_id,
        partner.campaign.project_id + '_' + owner.selectedCampaign.project_id,
        owner.selectedCampaign.project_id,
        partner.campaign.project_id
    ],
    users: [
        userId + '_' + partner.campaign.author_id,
        partner.campaign.author_id + '_' + userId,
        partner.campaign.author_id,
        userId
    ],
    status: 'pending',
    created_date: new Date(),
    cp_comment: owner.comment || null,
    isCounterOffer,
    seen: false
})


export const isAlreadyRequestedDate = (spots, campaignId) => spots.some(spot => spot && spot.cpid && spot.cpid === campaignId)

export const formSpots = spots => {
    return spots.map((item, index) => {
        let spot = {
            number: index + 1,
            busy: !!item,
        }
        if(item) {
            spot = {
                ...spot,
                ...item
            }
        }
        return spot
    })

}

export const formSelectedSpot = (spot, schedule) => {
    return {
        ...spot,
        index: -1,
        id: schedule.id,
        date: moment.unix(schedule.date.seconds).format('DD/MM/YYYY')
    }
}
